<template>
  <div class="modal" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-content box">
      <form @submit.prevent="saveSimulation">
        <SimulationForm :simulation="simulation"></SimulationForm>
        <div v-if="editingNewSimulation" class="field is-grouped">
          <div class="control">
            <button class="button" :class="{ 'is-loading': areStatsLoading }">
              Save
            </button>
          </div>
          <div class="control">
            <button class="button is-light" type="button" @click="cancelSimulation">
              Cancel
            </button>
          </div>
        </div>
        <div v-else class="control">
          <button class="button" :class="{ 'is-loading': areStatsLoading }">
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import SimulationForm from "./SimulationForm";
export default {
  name: "TheEditSimulationModal",
  components: { SimulationForm },
  computed: {
    simulation() {
      return this.$store.state.editableSimulation;
    },
    editingNewSimulation() {
      return !this.$store.state.simulations.includes(
        this.$store.state.editableSimulation
      );
    },
    areAllStatsLoaded() {
      return this.$store.getters.areAllStatsLoaded;
    },
    areStatsLoading() {
      return !this.$store.state.simulationIsBeingEdited && !this.areAllStatsLoaded;
    },
    isActive() {
      return this.$store.state.simulationIsBeingEdited || this.areStatsLoading;
    }
  },
  methods: {
    saveSimulation() {
      this.$store.dispatch("addStatsToEditableSimulation");
      if (this.editingNewSimulation) {
        this.$store.dispatch("addSimulation", this.simulation);
      }
      this.$store.dispatch("endEditingSimulation");
    },
    cancelSimulation() {
      this.$store.dispatch("endEditingSimulation");
    }
  }
};
</script>
